<template>
  <div>
    <div class="row">
      <div class="col-12 form-group">
        <label>{{ __("forms.Person.permission_tabs.documents.addNewPeople") }}</label>
        <select
          @change="addPersonPermission($event, module_id)"
          class="form-control"
          v-model="newPerson"
        >
          <option value="null">---</option>
          <option
            v-for="person in people"
            :value="person.id"
            :data-category="person.categoryName"
            v-bind:key="person.id"
          >
            {{ person.fullName }}
          </option>
        </select>
      </div>
      <div class="col-12 pb-2">
        <label>{{ __("forms.Person.permission_tabs.documents.searchPeople") }}</label>
        <input type="text" class="form-control" v-model="searchPerson" @change="search()" />
      </div>
      <div class="col-12" v-if="module_id == 1">
        <div
          class="row mt-2"
          v-for="(personPermission, index) in searchedPeoplePermissions"
          v-bind:key="index"
        >
          <div class="col-1">
            <button
              type="button"
              class="btn--danger btn"
              @click="removePersonPermissionFolder(personPermission.id)"
            >
              <i class="fas fa-trash"></i>
            </button>
          </div>
          <div class="col-1">
            <button
              type="button"
              class="btn--blue btn"
              @click="openFolderVisibility(personPermission.id)"
            >
              <i class="fas fa-folder"></i>
            </button>
          </div>
          <div class="col-8 pt-2">
            {{ personPermission.person_fullName }}
          </div>
        </div>
      </div>
      <div class="col-12" v-if="module_id == 12">
        <div
          class="row mt-2"
          v-for="(personPermission, index) in searchedPeoplePermissions"
          v-bind:key="index"
        >
          <div class="col-1">
            <button
              type="button"
              class="btn--danger btn"
              @click="removePersonPermissionFolder(personPermission.id)"
            >
              <i class="fas fa-trash"></i>
            </button>
          </div>
          <div class="col-1">
            <button type="button" class="btn--blue btn">
              <i
                class="fas fa-folder"
                @click="openFolderVisibility(personPermission.id)"
              ></i>
            </button>
          </div>
          <div class="col-3">
            {{ personPermission.person_fullName }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  mounted() {
    this.getPermissionFolders();
  },
  data() {
    return {
      newPerson: null,
      peoplePermissions: [],
      peopleNames: [],
      identifiable_name: "identifiable_name",
      searchPerson: "",
      searchedPeoplePermissions: [],
    };
  },
  methods: {
    
    openFolderVisibility(id) {
      app.__vue__.$refs.vue_popup.toggle(
        "folders",
        "/permission-folder-person-show-folders/folder_visibility_for_person/" +
          id
      );
    },
    
    removePersonPermissionFolder(permission_folder_id) {
      Vue.swal
        .fire({
          title: "Vuoi cancellare questa associazione",
          text: "Le informazioni non salvate verranno scartate",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Si",
        })
        .then((result) => {
          if (result.value) {
            axios
              .delete(
                "/delete-folder-visibility-for-person/" + permission_folder_id
              )
              .then((response) => {
                this.getPermissionFolders();
              })
              .catch(function (error) {
                alert(error);
              });
          }
        });
    },

    getPermissionFolders() {      
      axios
        .get(
          "/permission-folder-person/user/" +
            this.user_id +
            "/module/" +
            this.module_id
        )
        .then((response) => {          
          this.searchedPeoplePermissions = Object.values(response.data.permissions);
          this.peoplePermissions = Object.values(response.data.permissions);
          this.peopleNames = response.data.peopleArr;

          if (this.peoplePermissions != null){
            this.peoplePermissions.sort((a, b) => (a.person_fullName > b.person_fullName) ? 1 : -1);
          }
          
          if (this.searchedPeoplePermissions != null){
            this.searchedPeoplePermissions.sort((a, b) => (a.person_fullName > b.person_fullName) ? 1 : -1);
          }
          
        })
        .catch(function (error) {
          alert(error);
        });
    },

    addPersonPermission(event, module_id) {
      console.log("ADD", event, module_id);
      if (event.target.value !== null) {        
        axios
          .post(
            "/add-person-permission-folder/user/" +
              this.user_id +
              "/person/" +
              event.target.value +
              "/module/" +
              this.module_id
          )
          .then((response) => {
            this.getPermissionFolders();
          });
      }
    },
    
    search(){            
      
      if (this.searchPerson == null || this.searchPerson == "") {
        this.searchedPeoplePermissions = this.peoplePermissions;
        return;
      }

      this.searchedPeoplePermissions = [];
      for(let i = 0; i < this.peoplePermissions.length; i++){
        if (this.peoplePermissions[i].person_fullName.toLowerCase().indexOf(this.searchPerson.toLowerCase()) > -1) {
          this.searchedPeoplePermissions.push(this.peoplePermissions[i]);
        }
      }
    },
  },
  props: {
    user_id: {
      type: Number,
      required: true,
    },
    module_id: {
      type: Number,
      required: true,
    },

    people: {
      type: Array,
      required: true,
    },
    folders: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style>
</style>
